<div class="dmsanpham">


  <div class="row" *ngIf="tbatdau">
    <div class="start-check" style="width:100%">
      <div class="content-start-check ">
        <div class="top-test text-center padding-top40">
          <h3 class="text-title">{{datas.TenDotThi}}</h3>
        </div>
        <div style="margin: auto; width: 90%">
          <hr class="hr-start-check">
        </div>
        <div class="bottom-test text-center">
          <h3 class="text-start">{{'Số câu hỏi' | translate}}: {{datas.TongSoCauHoi}}</h3>
          <h3 class="text-start" *ngIf="datas.Loai===7">{{'Thời gian làm bài' | translate}}: {{thoigianlambais}} </h3>
          <button class="btn btn-primary" (click)="batdau()">{{'Bắt đầu' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="datas.DaThi==2">
    <div class="start-check" style="width:100%">
      <div class="content-start-check ">
        <div class="top-test text-center padding-top40">
          <h3 class="text-title">{{datas.TenDotThi}}</h3>
        </div>
        <div style="margin: auto; width: 90%">
          <hr class="hr-start-check">
        </div>
        <div class="bottom-test text-center">
          <h3 class="text-start">{{'Đã hết thời gian làm bài' | translate}}</h3>
         
        </div>
      </div>
    </div>
  </div>
  <div class="container" *ngIf="datas.DaThiXong">
    <div class="panelhan" style="padding-bottom: 20px; border-bottom: 1px solid #dee2e6;">
      <div class="panelhan-header" style="display:flex;justify-content:space-between;">
        <span>{{datas.TenDotThi}}</span>

      </div>
      <div class="panelhan-body row">
        <div class="col-sm row">
          <div class="col titlerow">
            {{'Số câu hỏi' | translate}}
          </div>
          <div class="col-4 valrow">
            {{datas.TongSoCauHoi}}
          </div>
        </div>
        <div class="col-sm row">
          <div class="col titlerow">
            {{'Số điểm yêu cầu' | translate}}
          </div>
          <div class="col-4 valrow">
            {{datas.SoDiemDat}}
          </div>
        </div>
        <div class="col-sm row">
          <div class="col titlerow">
            {{'Số điểm đạt' | translate}}
          </div>
          <div class="col-4 valrow">
            {{datas.DiemLyThuyet}}
          </div>
        </div>
      </div>
    </div>


  </div>

  <div class="row" *ngIf="!tbatdau && datas.DaThi!=2">
    <div class="col-12">
      <div class="main" style="display:block;color:black">
        <!--    <div class="container">-->
        <!--        <div class="row">-->
        <div class="col-md-12 content-questions">
          <div class="lecture-time" *ngIf="datas.Loai===7 && !datas.DaThiXong">
            <div class="lecture-time-content">
              <div class="total-time">
                <!--{{timeOut}}-->
                <span id="spanTimeout" class="value"></span>
              </div>
            </div>
          </div>
          <div *ngFor="let item of datas.ListCauHoi" id="item.Id">
            <div class="content-answer " data-id="{{item.Id}}" *ngIf="item.Loai==1">
              <h5 style="font-weight: 600; margin-left: 0px !important;">{{'Câu hỏi' | translate}} {{item.ThuTu}} ({{item.Diem}} {{'điểm' | translate}}):  <span style="color:darkblue" *ngIf="datas.DaThiXong">{{'Đáp án đúng' | translate}} {{item.DapAnDung}}</span></h5>
              <div class="content-single content-single-183099" id="content-single-{{item.ThuTu}}">
                <!--<p class="text-title"></p><p>cau hoi 1</p><p></p>-->
                <div class="text-title" style="font-weight:bold" [innerHtml]="item.NoiDung"></div>
                <table>
                  <tr *ngIf="item.SoPhuongAn>=1">
                    <td style="width:5px">
                      1
                    </td>
                    <td style="width:50px;text-align:center">
                      <input style="width:17px;height:17px" id="1-0-{{item.ThuTu}}" [disabled]="datas.DaThiXong" type="radio" [(ngModel)]="item.DaAn" name="single_choice_{{item.ThuTu}}" value="1">
                    </td>
                    <td>
                      <label for="1-0-{{item.ThuTu}}">&nbsp; {{item.PhuongAn1}}</label>
                    </td>
                  </tr>
                  <tr *ngIf="item.SoPhuongAn>=2">
                    <td style="width:5px">
                      2
                    </td>
                    <td style="width:50px;text-align:center">
                      <input style="width:17px;height:17px" id="1-1-{{item.ThuTu}}" [disabled]="datas.DaThiXong" type="radio" [(ngModel)]="item.DaAn" name="single_choice_{{item.ThuTu}}" value="2">
                    </td>
                    <td>
                      <label for="1-1-{{item.ThuTu}}">&nbsp; {{item.PhuongAn2}}</label>
                    </td>
                  </tr>
                  <tr *ngIf="item.SoPhuongAn>=3">
                    <td style="width:5px">
                      3
                    </td>
                    <td style="width:50px;text-align:center">
                      <input style="width:17px;height:17px" id="1-2-{{item.ThuTu}}" [disabled]="datas.DaThiXong" type="radio" [(ngModel)]="item.DaAn" name="single_choice_{{item.ThuTu}}" value="3">
                    </td>
                    <td>
                      <label for="1-2-{{item.ThuTu}}">&nbsp; {{item.PhuongAn3}}</label>
                    </td>
                  </tr>
                  <tr *ngIf="item.SoPhuongAn>=4">
                    <td style="width:5px">
                      4
                    </td>
                    <td style="width:50px;text-align:center">
                      <input style="width:17px;height:17px" id="1-3-{{item.ThuTu}}" [disabled]="datas.DaThiXong" type="radio" [(ngModel)]="item.DaAn" name="single_choice_{{item.ThuTu}}" value="4">
                    </td>
                    <td>
                      <label for="1-3-{{item.ThuTu}}">&nbsp; {{item.PhuongAn4}}</label>
                    </td>
                  </tr>
                </table>

              </div>


            </div>

            <div class="content-answer " data-id="{{item.Id}}" *ngIf="item.Loai==2">
              <h5 style="font-weight: 600; margin-left: 0px !important;">{{'Câu hỏi' | translate}} {{item.ThuTu}} ({{item.Diem}} {{'điểm' | translate}}): <span style="color:darkblue" *ngIf="datas.DaThiXong">{{'Đáp án đúng' | translate}} {{item.DapAnDung}}</span></h5>
              <div class="content-mutilpe content-mutilpe-183101">
                <div class="text-title" style="font-weight:bold" [innerHtml]="item.NoiDung"></div>
                <table>
                  <tr *ngIf="item.SoPhuongAn>=1">
                    <td style="width:5px">
                      1
                    </td>
                    <td style="width:50px;text-align:center">
                      <input class="input-checkbox" style="width:27px;height:27px" [disabled]="datas.DaThiXong" [(ngModel)]="item.DaAn1" id="2-0-{{item.ThuTu}}" type="checkbox" name="select_multi_{{item.ThuTu}}" value="Zt">
                    </td>
                    <td>
                      <label class="label-checkbox" for="2-0-{{item.ThuTu}}">&nbsp;{{item.PhuongAn1}}</label>
                    </td>
                  </tr>
                  <tr *ngIf="item.SoPhuongAn>=2">
                    <td style="width:5px">
                      2
                    </td>
                    <td style="width:50px;text-align:center">
                      <input class="input-checkbox" style="width:27px;height:27px" [disabled]="datas.DaThiXong" [(ngModel)]="item.DaAn2" id="2-1-{{item.ThuTu}}" type="checkbox" name="select_multi_{{item.ThuTu}}" value="zW">
                    </td>
                    <td>
                      <label class="label-checkbox" for="2-1-{{item.ThuTu}}">&nbsp;{{item.PhuongAn2}}</label>
                    </td>
                  </tr>
                  <tr *ngIf="item.SoPhuongAn>=3">
                    <td style="width:5px">
                      3
                    </td>
                    <td style="width:50px;text-align:center">
                      <input class="input-checkbox" style="width:27px;height:27px" [disabled]="datas.DaThiXong" [(ngModel)]="item.DaAn3" id="2-2-{{item.ThuTu}}" type="checkbox" name="select_multi_{{item.ThuTu}}" value="cm">
                    </td>
                    <td>
                      <label class="label-checkbox" for="2-2-{{item.ThuTu}}">&nbsp;{{item.PhuongAn3}}</label>
                    </td>
                  </tr>
                  <tr *ngIf="item.SoPhuongAn>=4">
                    <td style="width:5px">
                      4
                    </td>
                    <td style="width:50px;text-align:center">
                      <input class="input-checkbox" style="width:27px;height:27px" [disabled]="datas.DaThiXong" [(ngModel)]="item.DaAn4" id="2-2-{{item.ThuTu}}" type="checkbox" name="select_multi_{{item.ThuTu}}" value="si">
                    </td>
                    <td>
                      <label class="label-checkbox" for="2-3-{{item.ThuTu}}">&nbsp;{{item.PhuongAn4}}</label>
                    </td>
                  </tr>

                </table>


              </div>


            </div>

            <div class="content-answer " data-id="{{item.Id}}" *ngIf="item.Loai==3">
              <h5 style="font-weight: 600; margin-left: 0px !important;">{{'Câu hỏi' | translate}} {{item.ThuTu}} ({{item.Diem}} {{'điểm' | translate}}): </h5>

              <div class="content-essay content-essay-180744" id="content-essay-{{item.ThuTu}}">
                <div class="text-title" style="font-weight:bold" [innerHtml]="item.NoiDung"></div>
                <div class="text-answer">

                  <ejs-richtexteditor height='300px' #toolsRTE id='alltoolRTE_{{item.Id}}' [toolbarSettings]='tools' [showCharCount]='true' [(value)]='item.TuLuan'
                                      [maxLength]='maxLength' [fileManagerSettings]='fileManagerSettings' [quickToolbarSettings]='quickToolbarSettings'>
                  </ejs-richtexteditor>


                </div>
                <!--<button class="choose-file btn btn-primary" id="choose-file-180744">Tải lên đáp án</button>
                <p id="text-file-180744"></p>-->
                <div class="row" style="margin-top:4px">
                  <div class="control-label col-2">{{'Chấm điểm' | translate}}</div>
                  <div class="col-md-2">
                    <input class="form-control"
                           maxlength="20"
                           tabindex="7"
                           [disabled]="!quyen_suabaitap"
                           currencyMask
                           [(ngModel)]="item.DiemDatDuoc"
                           name="value"
                           [placeholder]="'Số điểm'"
                           [options]="ngxCurrencyOptions" autocomplete="off" />
                  </div>

                </div>

              </div>





            </div>

            <div class="content-answer " data-id="{{item.Id}}" *ngIf="item.Loai==0">
              <h5 style="font-weight: 600; margin-left: 0px !important;">{{'Câu hỏi' | translate}} {{item.ThuTu}} ({{item.Diem}} {{'điểm' | translate}}): <span style="color:darkblue" *ngIf="datas.DaThiXong">{{'Đáp án đúng' | translate}} {{item.DapAnDung}}</span></h5>

              <div class="content-true-false content-true-false-183100">
                <div class="text-title" style="font-weight:bold" [innerHtml]="item.NoiDung"></div>
                <table>
                  <tr>
                    <td style="width:5px">
                      1
                    </td>
                    <td style="width:50px;text-align:center">
                      <input style="width:27px;height:27px" id="4-0-{{item.ThuTu}}" [disabled]="datas.DaThiXong" type="radio" [(ngModel)]="item.DaAn" name="true_false_{{item.ThuTu}}" value="1">
                    </td>
                    <td>
                      <label for="4-0-{{item.ThuTu}}">&nbsp; {{item.PhuongAn1}}</label>
                    </td>
                  </tr>
                  <tr>
                    <td style="width:5px">
                      2
                    </td>
                    <td style="width:50px;text-align:center">
                      <input style="width:27px;height:27px" id="4-1-{{item.ThuTu}}" [disabled]="datas.DaThiXong" type="radio" [(ngModel)]="item.DaAn" name="true_false_{{item.ThuTu}}" value="2">
                    </td>
                    <td>
                      <label for="4-1-{{item.ThuTu}}">&nbsp; {{item.PhuongAn2}}</label>
                    </td>
                  </tr>
                </table>
                <!--<section style="padding: 0px 0px">

                  <div class="single-md-radio">
                    <input id="4-0-{{item.ThuTu}}" [disabled]="datas.DaThiXong" [(ngModel)]="item.DaAn" type="radio" name="true_false_{{item.ThuTu}}" value="1">
                    <label for="4-0-{{item.ThuTu}}">&nbsp;{{item.PhuongAn1}}</label>
                  </div>

                  <div class="single-md-radio">
                    <input id="4-1-{{item.ThuTu}}" [disabled]="datas.DaThiXong" [(ngModel)]="item.DaAn" type="radio" name="true_false_{{item.ThuTu}}" value="2">
                    <label for="4-1-{{item.ThuTu}}">&nbsp;{{item.PhuongAn2}}</label>
                  </div>


                </section>-->
              </div>

            </div>
            <hr>
            <div class="clearfix">
            </div>
          </div>
        </div>
        <div class="clearfix">
          <div class="text-center">
            <button style="margin-right:5px" *ngIf="!datas.DaThiXong || quyen_suabaitap" class="btn btn-success" (click)="savect()">{{'Gửi đáp án' | translate}}</button>
            <button *ngIf="quyen_suabaitap && datas.DaThiXong" class="btn btn-danger" (click)="deletedata(datas.Id)">{{'Xóa bài thi' | translate}}</button>
          </div>
        </div>

      </div>
      <!--        </div>-->
      <!--    </div>-->
    </div>
  </div>
</div>



